var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"label":"","small":"","link":"","color":_vm.color,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }